import React from "react";

export type TextFieldProps = {
  placeholder?: string;
  helpText?: string;
  onChange?: (value: string) => void;
  value?: string;
  disabled?: boolean;
};

export const TextField = ({
  disabled,
  placeholder,
  helpText,
  onChange,
  value = "",
}: TextFieldProps) => {
  return (
    <>
      <div className="gpc__text-field">
        <input
          type="text"
          placeholder={placeholder}
          onChange={(e) => onChange?.(e.target.value)}
          value={value}
          disabled={disabled}
        />
      </div>
      {helpText && <div className="gpc__text-field__help-text">{helpText}</div>}
    </>
  );
};

export default TextField;
